/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Funnel_Done_CtaInputs */

const en_funnel_done_cta = /** @type {(inputs: Funnel_Done_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open Listening`)
};

const es_funnel_done_cta = /** @type {(inputs: Funnel_Done_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abrir Listening`)
};

/**
* | output |
* | --- |
* | "Open Listening" |
*
* @param {Funnel_Done_CtaInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const funnel_done_cta = /** @type {((inputs?: Funnel_Done_CtaInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Funnel_Done_CtaInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_funnel_done_cta(inputs)
	return en_funnel_done_cta(inputs)
});